import { useTierContext } from '../TierProvider';

export const useIsFreemiumMember = () => {
  const {
    tier: { tierType },
  } = useTierContext();

  return tierType === 'FREE';
};
